import { Model } from "@vuex-orm/core";

export default class TemperatureCorrection extends Model {
  static entity = "temperature_corrections";

  static fields() {
    return {
      id: this.attr(null),
      enabled: this.attr(false),
      a: this.attr(0),
      b: this.attr(0),
      c: this.attr(0),
      d: this.attr(0),

      device_id: this.attr(null),
    };
  }
}
